import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { platformTheme } from '../platform';

export const registrationTheme = responsiveFontSizes(
  createTheme(platformTheme, {})
);
